import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { BookingProvider } from './context/BookingContext';
import { CountsProvider } from './context/CountsContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <CountsProvider>     
        <BookingProvider>
            <App />
        </BookingProvider>
      </CountsProvider> 
    </AuthProvider>
  </BrowserRouter>
);

